
import { Component, Vue } from 'vue-property-decorator';
import { UserModule } from '~/store/modules/user';
import BrandConsent from '~/components/User/Consents/PartnersConsents/BrandConsent.vue';

@Component({
    components: {
        BrandConsent,
    },
})
export default class CurrentConsents extends Vue {
    get userConsents() {
        return UserModule.brandsConsents;
    }
}
